module.exports = require('./helpers/bundle-url').getBundleURL('9NmXR') + "logo.c51670a8.svg";